<template>
    <div class="skillInfo assessment-mb" :class="{'skillInfoPC':$store.state.innerWidth>768}">
      <div class="topic-pc">
         <div class="info-content">
             <div>
                 <h2 class="Bold mainColor center">{{$t('message.Skill-Career Quiz')}}</h2>
                 <p class="dscr">{{$t('message.skillDesc')}}</p>
             </div>
         </div>
         <div class="li-content">
             <div>
                 <div class="item-table">
                     <div class="tdcell Bold number">
                         1.
                     </div>
                     <div class="tdcell">
                         {{$t('message.skillContent1')}}
                     </div>
                 </div>
                 <div class="item-table">
                     <div class="tdcell Bold number">
                         2.
                     </div>
                     <div class="tdcell">
                         {{$t('message.skillContent2')}}
                     </div>
                 </div>
                 <div class="item-table">
                     <div class="tdcell Bold number">
                         3.
                     </div>
                     <div class="tdcell">
                         {{$t('message.skillContent3')}}
                     </div>
                 </div>
                 <div class="startBtn">
                     <div class="btn btn-primary" @click="startEvent()" role="button" :aria-label="$t('message.Start')">
                        <a href="javascript:;" style="color: inherit">{{$t('message.Start')}}</a>
                    </div>
                 </div>
                 <a class="displayA" v-bind:href="'./selfSkillTopic?lang='+$store.state.language"></a>
             </div>
         </div>
       </div>
    </div>
</template>
<script>
import Breadcrumbs from '@/components/Breadcrumbs'
export default {
    components: {
       Breadcrumbs
    },
    data() {
        return {
            
        }
    },   
    props: ["logGaEvent"],
    created(){
    },
    methods: {
      startEvent:function(){
          this.logGaEvent('userClick','selfSkillInfo',"selfSkillTopic")
        this.$router.push({ path: '/selfSkillTopic' , query:{lang:this.$store.state.language}});
         window.scrollTo(0, 0);
      }
    },
    mounted() {
        this.$store.state.selectMenu =5;
        this.$store.state.mate.title = this.$i18n.t("message.Self-Assessment")+" - talent.gov.hk"
    }


   
}
</script>